<template>
  <e-modal
    ref="vdialog"
    v-model="isActive"
    eager
    :max-width="getWidth"
    :persistent="persistent || loading"
    :retain-focus="false"
    :title="title"
    :button-close="actions['close']"
    :button-submit="actions['submit']"
    @click:close="(e) => trigger('close', e)"
    @click:submit="(e) => trigger('submit', e)"
  >
    <template v-if="$options.propsData.customContentSlot" #content>
      <dialog-child ref="dialog" v-bind="$options.propsData" />
    </template>
    <dialog-child v-else ref="dialog" v-bind="$options.propsData" />
  </e-modal>
</template>

<script>
import { EModal } from '../../../components/vuetify'
import Actionable from '../mixins/actionable'

export default {
  name: 'EDialogLayout',

  components: {
    EModal,
  },
  mixins: [Actionable],

  props: {
    fullscreen: Boolean,
    persistent: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    customContentSlot: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    _destroy() {
      // Allow to draw transition, cause vuetify doesn't have onClose method
      setTimeout(() => {
        this.$destroy()
      }, 1000)
    },
  },
}
</script>
